import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const VerifyOtpApi = createAsyncThunk(
  'VerifyOtpApi',
  async (verifyOtpPayload, { dispatch }) => {
    dispatch({ type: 'VerifyOtpApi/pending', payload: {} });
    const { customerId, Authorization, customerRefNum, otpCode, templateType } =
      verifyOtpPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'esqa/verifyotpexistingcustomer',
      payload: {
        customerRefNum,
        templateType,
        otpCode,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const verifyOtpRes = res;
        dispatch({
          type: 'VerifyOtpApi/fulfilled',
          payload: verifyOtpRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'VerifyOtpApi/rejected', payload: err });
      },
    });
  }
);

export const VerifyOtpApi_extrareducer = {
  [VerifyOtpApi.pending]: (state, action) => {
    state.verifyOtpApiState.isLoading = true;
  },
  [VerifyOtpApi.fulfilled]: (state, action) => {
    state.verifyOtpApiState.isLoading = false;
    state.verifyOtpApiState.isSuccess = true;
    state.verifyOtpApiState.isError = false;
    state.verifyOtpApiState.response = action.payload;
  },
  [VerifyOtpApi.rejected]: (state, action) => {
    state.verifyOtpApiState.isLoading = false;
    state.verifyOtpApiState.isSuccess = false;
    state.verifyOtpApiState.isError = true;
    state.verifyOtpApiState.response = action.payload;
  },
};
